Ext.define('SA.view.ProjectSettings', {
    alias: 'widget.project-settings',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-project-settings',

    initComponent() {
        this.items = [
            {
                xtype: 'project-settings-header'
            }, {
                xtype: 'simple-container',
                cls: 'sa-project-settings-body',

                items: [
                    {
                        xtype: 'general-settings',
                        project: this.projectView
                    }, {
                        xtype: 'manage-views',
                        project: this.projectView,
                        hidden: true
                    }, {
                        xtype: 'remove-building-blocks',
                        hidden: true
                    }
                ]
            }
        ];

        this.callParent();

        this.header = this.down('project-settings-header');
        this.generalSettings = this.down('general-settings');
        this.manageViews = this.down('manage-views');
        this.removeBuildingBlocksCmp = this.down('remove-building-blocks');
    },

    afterRender() {
        this.callParent();

        this.refresh();
    },

    initEvents() {
        this.callParent();

        this.mon(this.projectView, {
            scope: this,
            buffer: 10,

            'change:attribute': this.refresh,
            'change:businessSearch': this.refresh,
            'change:location': this.refresh,
            'change:view': this.refresh,
            'change:view:attribute': this.refresh,
            'change:view:businessSearch': this.refresh,
            'change:view:location': this.refresh,
            'change:view:name': this.refresh
        });

        this.mon(SA.data.LocationAliases, {'change': this.refresh, scope: this, buffer: 10});
        this.mon(SA.data.BusinessSearches, {'change:name': this.refresh, scope: this, buffer: 10});

        this.header.on('click:sectionLink', this.onClickSectionLink, this);

        this.generalSettings.on('click:deleteProject', this.onClickDeleteProject, this);
        this.generalSettings.on('toggle:historicalViews', this.onToggleHistoricalViews, this);

        this.removeBuildingBlocksCmp.on('click:location', this.onClickRemoveLocation, this);
        this.removeBuildingBlocksCmp.on('click:attribute', this.onClickRemoveAttribute, this);
        this.removeBuildingBlocksCmp.on('click:businessSearch', this.onClickRemoveBusinessSearch, this);
    },

    onClickDeleteProject() {
        Ext.widget({xtype: 'delete-project-popup', project: this.projectView});
    },

    onClickRemoveLocation({id}) {
        this.projectView.removeLocation(id);
        this.projectView.save();
    },

    onClickRemoveAttribute({id}) {
        this.projectView.removeAttribute(id);
        this.projectView.save();
    },

    onClickRemoveBusinessSearch({id}) {
        this.projectView.removeBusinessSearch(id);
        this.projectView.save();
    },

    onClickSectionLink(section) {
        this.generalSettings.setVisible(section === 'generalSettings');
        this.manageViews.setVisible(section === 'manageViews');
        this.removeBuildingBlocksCmp.setVisible(section === 'removeBuildingBlocks');
    },

    onToggleHistoricalViews(enabled) {
        this.fireEvent('toggle:historicalViews', enabled);
    },

    refresh() {
        this.removeBuildingBlocksCmp.setData({
            locations: SA.data.LocationsCache.get(this.projectView.getLocations()),
            attributes: SA.data.AttributesCache.get(this.projectView.getAttributes()),
            businessSearches: SA.data.BusinessSearches.get(this.projectView.getBusinessSearches())
        });

        this.manageViews.refresh();
    }
});